import { DeviceSettings } from '../models/deviceSettings'

export interface DeviceSettingsStateType {
  deviceSettings: DeviceSettings[]
  singleDeviceSettings: DeviceSettings | null
}

const DeviceSettingsState: () => DeviceSettingsStateType = () => ({
  deviceSettings: [],
  singleDeviceSettings: null,
})

export default DeviceSettingsState
